import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IItemHierarchyLookup } from 'src/common/interfaces/dtos/IItemHierarchyLookup';
import { IItemHierarchyLookupDto } from 'src/common/interfaces/dtos/IItemHierarchyLookupDto';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const itemHierarchyLookup = (
  data: IItemHierarchyLookupDto,
): Promise<IItemHierarchyLookup[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/items/get-item-hierarchy`,
    method: 'POST',
    data: data,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<IItemHierarchyLookup[]>(emeraldRequestParams);
};
